import { TabManager, TabMenu, TabContent } from './TabManager'

export default { 
  Manager: TabManager, 
  Menu: TabMenu, 
  Content: TabContent 
}